<script>
import Modal from './Modal.svelte'
import { createEventDispatcher } from "svelte";

export let showModal;
export let isUpdating=false;
  let dispatch = createEventDispatcher();
</script>

<Modal bind:showModal={showModal}>
  <slot/>
  <footer class="modal-card-foot buttons is-right" slot="footer">
   <button
      class="button"
      on:click={() =>{ 
        showModal = false;
        dispatch('cancel')
        }}>
      Cancel
    </button>
    <button
    class="button is-primary {isUpdating ? 'is-loading' : ''}"
    disabled={isUpdating}
      on:click={() => dispatch('ok')}>
      Ok
    </button>
  </footer>
</Modal>